// auth.guard.ts
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LoginService } from './login.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private jwtHelper: JwtHelperService, private loginService: LoginService, private router: Router) {}

  canActivate() {
    const token = this.loginService.getJwtToken();
    
    try {
      this.jwtHelper.decodeToken(token);
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        return true;
      } else {
        this.router.navigate(["login"]);
      }
    }
    catch (excp) {
      this.router.navigate(["login"]);
    }
    return false;
  }
}
